  <template >
  <div>
  <div>
  <div class="formPosition">
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
<v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-data-table    :headers="headers"  :items="estudantes" :search="searchInDb"    class="elevation-3" >
      <template v-slot:top>
        <v-toolbar flat color="white">

       <!--  <v-btn to="/painelclasses" > <v-icon large color="green darken-2">arrow_back</v-icon> </v-btn > -->

          <v-toolbar-title>Finalistas
            </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
            <v-select style="margin-top:25px;width:250px;"
              :items="instituicao"
              v-model="instituicaoSelecionada"
              @change="PesquisarEstudanteInstituicao()"
              item-value="idInstituicao"
              item-text="descricao"
              label="Selecione a instituição"
          ></v-select>
          <v-select style="margin-top:25px;margin-left:10px;width:150px;"
              :items="anolectivos"
              v-model="anolectivoSelected"
              @change="PesquisarEstudantes()"
              item-value="descricao"
              item-text="descricao"
              label="Selecione o anolectivo"
          ></v-select>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-select style="margin-top:25px;margin-left:10px;width:150px;"
              :items="opcoesOrdenacao"
              v-model="ordenacao"
              item-text="descricao"
              item-value="id"
              @change="Ordenar()"
              :disabled="!estudantes.length"
              label="Opções de Ordenação"
          ></v-select>

          <v-btn :disabled="!estudantes.length" color="green" icon><img @click="teste()" style="margin-left:30px"  width="30px"  src="../../assets/download.png"></v-btn>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-btn :disabled="!estudantes.length" color="primary" @click="dialogP = true"><v-icon color="white">picture_as_pdf</v-icon></v-btn>
          <!--  search  -->
    <div   v-if="$store.state.hasMessage && cor=='red'" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

          <div class="flex-grow-1"></div>
          <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          <v-text-field
            v-model="searchInDb"
            append-icon="search"
            label="Pesquisa por nome"

            single-line
            hide-details
          ></v-text-field>
          <!-- end  search  -->

          <v-dialog v-model="dialog" max-width="800px">

            <v-card>

              <template >

                  <v-toolbar color="grey lighten-2">

             <v-row>
                    <v-col  cols="12" md="4">

<v-btn text    @click="close"><v-icon large color="primary" >clear</v-icon></v-btn>

    </v-col>

     <v-col cols="12" md="7">  <!--  form titlte section   {{ formTitle }}-->
   Cadastrar   <span v-if="idclasse===1"> 10ª classe</span>
          <span v-if="idclasse===2"> 11ª classe</span><span v-if="idclasse===3"> 12ª classe</span>
          <span v-if="idclasse===4"> 13ª classe</span>
     </v-col>

      <v-col  cols="12" md="1">
     <v-btn   :disabled="!valid"           color="primary" text  @click="save"><v-icon large color="primary" >send</v-icon></v-btn>
   </v-col>

  </v-row>

                  </v-toolbar>

              </template>

 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                  <v-row>
                    <v-col  cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nome"
                        label="Nome"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                      required
                        :rules="ruleBI"
                        v-model="editedItem.bi"
                        :label="descricao"
                        v-mask="mascara"
                      ></v-text-field>

                    </v-col>
                    <v-col cols="12" md="2">
                      <v-switch  @change="outroDoc()"></v-switch>
                    </v-col>

 <v-col cols="12" md="3">

   <template>

  <v-menu
    ref="menubi"
    v-model="menubi"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field

        v-model="editedItem.dataemissaobi"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de emissâo do BI"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      max="2019-12-31"
      min="1950-01-01"
      v-model="datebi"
      @change="saveDatebi"
    ></v-date-picker>
  </v-menu>
</template>
</v-col>

 <v-col cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-if="false"
                        v-model="editedItem.pkPessoa"
                        label="chave primaria auto increemente"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>

                    <v-col cols="12" md="4">

                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nomedopai"

                        label="Filho de:"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nomedamae"

                        label=" e de:"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                   <template>

  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field

        v-model="editedItem.datanascimento"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de nascimento"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
  </template>
    <v-date-picker
      ref="picker"

      v-model="date"
     max="2006-12-31"
      min="1950-01-01"
      @change="saveDate"
    ></v-date-picker>
  </v-menu>
</template>

                    </v-col>

                  </v-row>

                   <v-row>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :rules="ruleRequired"
                        v-model="proviSelectedForComb"
                        :items="provincias"
                        item-value="idProvicia"
                        item-text="descricao"
                          @change="loadMunicipioComb"
                          @click="loadMunicipioComb"

                        chips
                        label="Natural de:"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :rules="ruleRequired"
                        v-model="municSelectedForComb"
                        :items="municipiosFiltered"
                        item-value="idMunicipio"
                        item-text="descricao"
                        chips
                        label="Municipio"
                      ></v-combobox>
                    </v-col>
                     <v-col cols="12" md="4">
                      <v-combobox
                        v-model="editedItem.sexo"
                        :rules="ruleRequired"
                        item-value="idSexo"
                        item-text="descricao"
                        :items="dropdowSexo"
                        chips
                        label="Sexo"
                      ></v-combobox>
                    </v-col>

                  </v-row>
                   <v-row>

   <v-col cols="12" md="4">
                      <v-combobox
                              v-if="true"
                                v-model="editedItem.curso"
                                :rules="ruleRequired"
                                item-value="idCurso"
                                item-text="descricao"
                                  @change="loadTurmaComb"
                                  @click="loadTurmaComb"

                                :items="cursos"
                                chips
                                label="Curso"
                      ></v-combobox>

                    </v-col>

<v-col cols="12" md="4">

                      <v-combobox  id="turma"
                      v-if="true"
                        v-model="editedItem.turma"
                        :rules="ruleRequired"
                        :value="undefined"
                        item-value="idTurma"
                        item-text="turmadescricao"
                        :items="turmasFiltered"
                        chips
                        label="Turma"
                      ></v-combobox>
                    </v-col>
<v-col cols="12" md="4">
                      <v-text-field
                      v-model="editedItem.telefone"

                       label="Telefone">
                       </v-text-field>
                  </v-col>

        </v-row>

                </v-container>
              </v-card-text>

      </v-form>

            </v-card>
          </v-dialog>
        </v-toolbar>
        </template>
        <template v-slot:item.foto="{ item }">
         <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-list-item-avatar>

                  <v-img v-if="item.foto" v-on="on" :src="foto_parte1 + item.idMatricula + foto_parte2"></v-img>
                  <v-img v-if="!item.foto" v-on="on" src="http://restrito.esaudeluanda.com:7000/config/nulo-foto.jpg"></v-img>
            </v-list-item-avatar>
            </template>
           {{item.foto}}
               <v-img v-if="item.foto" v-on="on" :src="foto_parte1 + item.idMatricula + foto_parte2"></v-img>
              <v-img v-if="!item.foto" v-on="on" src="http://restrito.esaudeluanda.com:7000/config/nulo-foto.jpg"></v-img>
            <!-- <v-img v-if="!item.foto"   src="http://restrito.esaudeluanda.com:7000/config/IMS/file/5980-foto.jpg"></v-img>-->
        </v-tooltip>
        </template>
      <template v-slot:item.action="{ item }">
          <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon color="green darken-3" v-on="on" size="25" class="mr-2" @click="search(item)">receipt</v-icon>
           </template>
          <span>Visualizar o histórico académico</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
     <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->

     Clica em + para adicionar novo estudante
      </template>
    </v-data-table>

<!--======================================EXPORTAR PARA O PDF==============================================-->
  <template>
  <div class="text-center">
    <v-dialog
      v-model="dialogP"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-1"
          primary-title
        >
         Exportar para PDF - Deseja Continuar
        </v-card-title>

        <v-card-text>
            Clique em <b>Continuar</b> para exportar os dados em PDF.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="background-color:red;color:white" @click="dialogP=false">Cancelar</v-btn>
          <v-btn @click="print(estudantes)">Continuar</v-btn>
         </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </template>
<!--==========================================================================================-->
<!--======================================EXPORTAR PARA O EXECEL==============================================-->
  <template>
  <div class="text-center">
    <v-dialog
      v-model="dialogE"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-1"
          primary-title
        >
         Exportar para Excel - Deseja Continuar
        </v-card-title>

        <v-card-text>
            Clique para Continuar
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="background-color:red;color:white" @click="dialogE=false">Cancelar</v-btn>
           <export-excel
                :data   = "estudantes"
              :fields="campos"
              >
          <v-btn @click="dialogE=false">Continuar</v-btn>
        </export-excel>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </template>
<!--==========================================================================================-->
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    datebi: null,
    date: null,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    fInst: true,
    ordenacao: 1,
    fAn: true,
    menubi: false,
    dialogP: false,
    habilitaBi: false,
    startDate: null,
    instituicaoSelecionada: null,
    anolectivoSelected: ls.get('anolectivo'),
    cursos: [],
    instituicaoLogada: ls.get('instituicaodescricao'),
    instituicao: [],
    anolectivos: [],
    isLoading: true,
    turmasAll: [],
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    cor: '',
    overlay: false,
    municipiosFiltered: [],
    foto_parte1: 'http://restrito.esaudeluanda.com:7000/config/IMS/file/',
    foto_parte2: '-foto.jpg',
    provincias: [],

    searchInDb: '',
    opcoesOrdenacao:
    [
      { id: 1, descricao: 'Por Nome' },
      { id: 2, descricao: 'Por Curso' }
    ],
    estudantes: [],
    dialogE: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome',
        align: 'left',
        value: 'nome'
      },

      { text: 'Bilhete de Identidade / Outro documento', value: 'bi' },
      { text: 'Matricula', value: 'idMatricula' },
      { text: 'Curso', value: 'curso' },
      { text: 'Turma', value: 'turma' },
      { text: 'Anolectivo', value: 'anoLectivo' },
      { text: 'Resultado', value: 'resultado' },
      { text: 'Instituição', value: 'instituicao' },
      { text: 'Data de Cadastro/Moficação', value: 'data_' },
      { text: 'Actions', value: 'action' }
    ],

    campos: {
      'Nome Completo': 'nome',
      'Bilhete de identidade': 'bi',
      'Matrícula': 'idMatricula',
      'Curso': 'curso',
      'Turma': 'turma',
      'Anolectivo': 'anoLectivo',
      'Resultado': 'resultado',
      'Instituição': 'instituicao',
      'Data de cadastro': 'data_'
    },

    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {

      pkPessoa: 0,
      bi: null,
      idPessoa: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: null,
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    if (this.instituicaoLogada !== 'EFTSLuanda') { this.$router.push('denied') }
    // this.CarregActividades()
    this.initializeAnolectivo()
    this.initializeInstituicao()
    this.initialize()
  },

  methods: {
    async initialize (searchInDb) {
      try {
        //   let  payload =""
        if (!searchInDb) {
          var payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + searchInDb + '"}'
        }

        this.isLoading = true
        this.estudantes = await axios
          .get('/estudanteFinalistasFindAll-geral/' + payload + '/' + this.instituicaoSelecionada + '/' + this.anolectivoSelected + '/' + this.ordenacao)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    // METHODO FOR VALIDATION
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.descricao = 'Nº do Bi'
      } else {
        this.descricao = 'Outro Doc.'
      }
    },

    PesquisarEstudanteInstituicao () {
      this.initialize()
    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },
    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },
    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async initializeAnolectivo () {
      try {
        this.anolectivos = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
        this.anolectivos.unshift({ descricao: 'Todos', pk: -1 })
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async initializeInstituicao () {
      try {
        this.isLoading = true
        this.instituicao = await axios
          .get('/listarInstituicao')
          .then(res => res.data)
        this.instituicao.unshift({ idInstituicao: -1, descricao: 'Todas' })
        this.instituicaoSelecionada = -1
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },

    PesquisarEstudantes () {
      this.initialize()
    },

    search (item) {
      this.$store.state.objaluno = item
      this.$router.push('estudante-historico')
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    teste () {
      this.dialogE = true
    },

    async initializeturmasAll () {
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + this.idclasse)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    editItem (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      this.dialog = true
    },

    deleteItem (item) {
      const index = this.estudantes.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.delete(item.pkInscricao_na_turma)
      // this.estudantes.splice(index, 1)*/
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(date).toISOString().substr(0, 10)
    },
    async save () {
      if (this.$refs.form.validate()) {
        const ls = require('local-storage')
        var params = {
          pkPessoa: this.editedItem.pkPessoa,
          idPEssoa: this.editedItem.bi,
          idMunicipio: this.municSelectedForComb.idMunicipio,
          idPerfil: 1,
          nome: this.editedItem.nome,
          morada: this.editedItem.morada,
          telefone: this.editedItem.telefone,
          autor: ls.get('idPessoa'),
          datanascimento: this.editedItem.datanascimento,
          data_: this.editedItem.data_,
          status_2: this.editedItem.status_2,
          email: this.editedItem.email,
          sexo: 'M',
          nomedopai: this.editedItem.nomedopai,
          nomedamae: this.editedItem.nomedamae,
          dataemissaobi: this.editedItem.dataemissaobi,
          bi: this.editedItem.bi,
          ResidenteEm: 1,
          instituicao: ls.get('i_id'),
          instituicaodescricao: this.editedItem.instituicaodescricao,
          curso: this.editedItem.curso,
          turma: this.editedItem.turma,
          anolectivo: ls.get('anolectivo'),
          idanolectivo: ls.get('idanolectivo'),
          idanoacademico: this.idclasse
        }
        try {
          let msg = await axios
            .post('/estudanteInsertOrUpdate', params)
            .then(res => res.data)
          // this.text = msg[1].insertId
          this.text = msg
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })

          try {
            if (msg.affectedRows >= 1) {
              this.text = msg.affectedRows + ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 2000 })
            }
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
          } catch (error) {}

          if (this.editedIndex > -1) {
          //  Object.assign(this.estudantes[this.editedIndex], this.editedItem)
          } else {
            this.estudantes.unshift(this.editedItem)
          }
          //  this.close();

          this.initialize()
        } catch (error) {
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        } finally {

        }
        if (this.$store.msg === 'Número de Bi ja existente');
        else {
          this.editedItem.nome = ''
          this.editedItem.nomedopai = ''
          this.editedItem.nomedamae = ''
          this.editedItem.datanascimento = ''
          this.editedItem.dataemissaobi = ''
          this.editedItem.bi = ''
          this.editedItem.sexo = ''
          this.editedItem.telefone = ''
          this.editedItem.municipio = ''
          this.editedItem.provincia = ''
          this.$refs.form.resetValidation()
          if (this.editedItem.pkPessoa) {
            this.editedItem.pkPessoa = null
            setTimeout(() => {
              this.close()
            }, 1000)
          }
        }
      }
    },

    async delete (idv) {
      try {
        var msg = await axios
          .get('/estudanteDeleteById/' + idv)
          .then(res => res.data)
        this.text = 'Deleted ' + msg.message

        this.initialize()

        this.close()
      } catch (error) {
        this.text = error.message
      } finally {

      }
    },

    async Ordenar () {
     this.initialize()
    },

    async gerarPdf (option) {
      this.progresso = true
      try {
        await axios({
          method: 'post',
          url: 'http://relatorios.softlineangola.com/writefile', //  http://relatorios.softlineangola.com
          data: {
            html: this.html,
            file_name: ls.get('nomeUsuario'),
            option: option,
            permissao: '2121'
          }
        }).then(function (response) {
          console.log('sucesso ')
        })
        // Imprimir PDF

        this.progresso = false
        this.frame()
      } catch (error) {
        this.progresso = false
      }
    },

    frame () {
      // this.url = 'http://relatorios.softlineangola.com/readfile/' + ls.get('nomeUsuario') + '.pdf'
      let link = 'http://relatorios.softlineangola.com/readfile/' + ls.get('nomeUsuario') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + link + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
      this.progresso = false
    },
    async print (dados) {
      this.overlay = true
      this.dialogP = false
      let headerHtml = `Lista dos Finalistas de ` + this.anolectivoSelected
      if (this.anolectivoSelected === 'Todos') { headerHtml = ` Lista de Todos Finalistas` }
      try {
        this.progresso = true
        let option = { 'format': 'A4',
          'border': { 'top': '10cm', // default is 0, units: mm, cm, in, px
            'right': '25cm',
            'bottom': '20cm',
            'left': '25cm'
          },
          'header': {
            'height': '5mm' },
          'footer': {
            'height': '10mm'
          } }
        // Chamando o report
        let i = 0
        let htmlDadosFinalistas = ``
        dados.forEach(element => {
          i++
          htmlDadosFinalistas += ` <tr style="font: 8px  Andale Mono, monospace;" class="` + this.zebraListaFinalista(i) + `">
                     <td>` + i + `</td>
                    <td>` + element.nome + `</td>
                    <td align="center">` + element.bi + `</td>
                    <td align="center">` + element.idMatricula + `</td>
                    <td align="center">` + element.curso + `</td>
                    <td align="center">` + element.anoLectivo + `</td>
                    <td align="center">` + element.resultado + `</td>
                     <td align="center">` + element.instituicao + `</td>
                     
                </tr>`
        })

        this.html = `
<html>
<head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
    <style>
#customers {
 
  width: 100%;
}

#customers td, #customers th {
 
  padding: 8px;
}

#customers tr:nth-child(even){background-color: #f2f2f2;}

#customers tr:hover {background-color: #808080;}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #4CAF50;
  color: white;
}
table, th, td {
  
  padding-top:10px
  padding-left:25px
  padding-buttom:10px
}
 .background {
   background-image: url("http://relatorios.softlineangola.com/readfile/back.gif");
   height: 770px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%, 100%;
  position: relative;
 }
 .zebr{
        background-color: #DCDCDC;
    }

    </style>
</head>
<body>
    <div>
                        
<center style="padding-top:10px"> <img src="http://relatorios.softlineangola.com/readfile/insignia.png" alt="Snow" style="width:50%; max-width:50px;" /> </center><br>
                             <center style="font: 10px Andale Mono, monospace;">  REPÚBLICA DE ANGOLA <br>
                           MINISTÉRIO DA EDUCAÇÃO <br>
                        ESCOLA DE FORMAÇÃO DE TÉCNICOS DE SAÚDE DE 
                        LUANDA</center> <br>
                        <center style="font: 10px Andale Mono, monospace;"><h2> ` + headerHtml + `</strong></h2> <br>
             
            <table id="customers">                                             
                <tr style="font: 10px  Andale Mono, monospace; background-color: #DCDCDC; border:1px solid black" >
                <td align="center" ><strong>Ord.</strong></td>
                  <td align="center" width="50%" ><strong>Nome</strong></td>
                    <td align="center"  width="20%" ><strong>Bilhete de Identidade</strong></td>
                    <td align="center" width="40%" ><strong>Matricula</strong></td>
                    <td align="center" width="20%" ><strong>Curso</strong></td>
                    <td align="center" width="20%" ><strong>Ano Lectivo</strong></td>
                    <td align="center" width="20%" ><strong>Resultado</strong></td>
                     <td align="center" width="20%" ><strong>Instituição</strong></td>
                     
                </tr>

               ` + htmlDadosFinalistas + `
        
            </table>
    
    </body>
</html>
`
        this.gerarPdf(option).then(() => {
          this.overlay = false
        })
      } catch (error) {
        this.progresso = false
        this.overlay = false
      } finally {
      }
    },
    zebraListaFinalista (i) {
      if (i % 2) {
        return 'zebr'
      } else {
        return ''
      }
    },
    monthName () {
      let d = new Date()
      let month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Maço'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return month[d.getMonth()] + ' ' + 'de' + ' ' + (d.getFullYear()).toString()
    },
    dia () {
      var day = new Date()
      day = day.getDate()
      day = day.toString()
      return day
    }

  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
